import { configEnum } from "../enum";
export var nextDate = function nextDate(date) {
  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return new Date(date.getFullYear(), date.getMonth(), date.getDate() + amount);
};
export var getDateEnd = function getDateEnd(time) {
  return new Date(nextDate(time) - 1);
};
export var getDateStart = function getDateStart(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};
export var getLimitAgo = function getLimitAgo() {
  var MONTH = (configEnum.rangeLimitDay - 1) * 24 * 60 * 60 * 1000;
  return getDateStart(new Date(Date.now() - MONTH));
};
export var getDateStampEndOfMonth = function getDateStampEndOfMonth(date) {
  return new Date(date.getFullYear(), date.getMonth() + 1, 1).getTime() - 1;
};